import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {injectIntl} from 'react-intl';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import getTranslatedText from '../../../../../../../../services/getTranslatedText';
import _ from 'lodash';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CopyWidgetsMutation from '../../../../../../../../mutations/CopyWidgetsMutation';



function getStateFromProps(props) {
  const selectedWidgets = ((props && props.report && props.report.widgets) || []).map(w => w.id);

  return {
    selectedWidgets,
    destinationReports: [],

  };
}



@injectIntl
class CopyWidgetsDialog extends Component {

  constructor(props) {
    super(props);
    this.state = getStateFromProps(props);
  }

  /**
   * 
   * @param {*} widgetId 
   * @param {*} checked 
   */
  updateSelectedWidgets = (widgetId, checked) => {

    const newSelectedWidgets = this.state.selectedWidgets.slice();
    if (checked && this.state.selectedWidgets.indexOf(widgetId) === -1) {
      newSelectedWidgets.push(widgetId);
    }

    if (!checked && this.state.selectedWidgets.indexOf(widgetId) !== -1) {
      const index = this.state.selectedWidgets.indexOf(widgetId);
      newSelectedWidgets.splice(index, 1);
    }

    this.setState({selectedWidgets: newSelectedWidgets});

  };

  /**
   * 
   */
  handleDestinationReportChange = (value) => {
    this.setState({destinationReports: value});
  };

  save = () => {

    CopyWidgetsMutation.commit({
      destinationReportIds: this.state.destinationReports,
      widgetIds: this.state.selectedWidgets,
    },
    (error, data) => {

      if (this.props.onClose && typeof this.props.onClose === 'function') {
        this.props.onClose();
      }
    });

  };

  cancel = () => {
    if (this.props.onClose && typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  };

  getWidgets = () => {
    return (this.props && this.props.report && this.props.report.widgets) || [];
  }

  translate = (w) => {
    let t = '';
    if (w && w.config && w.config.question && w.config.question.text) {
      t = w.config.question.text;
    } else {
      return w.name || `Widget ${w.id}`;
    }
    return getTranslatedText(t);
  }

  getWidgetName = (w) => {
    let name = this.translate(w);
    if (w.name) {
      name = name + ' (' + w.name + ')'
    }
    return name
  }
  render() {

    const widgets = this.getWidgets();
    const reportEdges = (this.props.reports && this.props.reports.edges) || [];
    const reports = reportEdges.map(edge => edge.node).filter(Boolean);

    const dialogActions = [
      <FlatButton 
        label="Cancel"
        onTouchTap={this.cancel}
      />,
      <RaisedButton 
        label="Save"
        primary={true}
        onTouchTap={this.save}
      />,
    ];

    return (
      <Dialog
        title="Copy widgets"
        open={this.props.open}
        autoScrollBodyContent={true}
        actions={dialogActions}
        onRequestClose={this.cancel}
        >

        {widgets.map(w => 
          <Checkbox
            key={w.id}
            label={this.getWidgetName(w)}
            checked={_.includes(this.state.selectedWidgets, w.id)}
            onCheck={(event, checked) => this.updateSelectedWidgets(w.id, checked)}
          />
        )}

        <SelectField 
          key={`select-field-${this.props.report.id}}`}
          multiple={true}
          value={this.state.destinationReports}
          onChange={(event, index, value) => this.handleDestinationReportChange(value)}
          autoWidth={true}
          style={{
            width: '100%',
          }}
          floatingLabelText={'Destination Report'}
          >
          {(reports || []).map((report) =>
            <MenuItem
              key={`menu-item-${report.id}`}
              value={report.id}
              primaryText={report.name}
              insetChildren={true}
              checked={report.id === this.state.destinationReports}
            />
          )}
        </SelectField>

      </Dialog>
    );
  }
}

export default createFragmentContainer(
  CopyWidgetsDialog,
  graphql`
    fragment CopyWidgetsDialog_reports on ReportConnection {
      edges {
        node {
          id
          name
        }
      }
    }
    fragment CopyWidgetsDialog_report on Report {
      id
      widgets {
        id
        name
        config {
          question {
            id
            text {
              text
              language
            }
          }
        }
      }
    }
  `,
);





// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/CopyWidgetsDialog/CopyWidgetsDialog.js